import WhyQmee from 'components/pages/WhyQmee/WhyQmee';
import { buildPage } from 'utils/pageHelper';
export default buildPage(WhyQmee, {
  fullPage: true,
  metaData: {
    title: 'Why Qmee?',
    description:
      'Check out these awesome reasons why you should choose Qmee and our amazing community!',
  },
});
